import React, { useEffect, useState } from "react";
import "./Study.css";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import parse from "html-react-parser";
import { Button } from "react-bootstrap";
import { withRouter } from "react-router";
import { post } from "../../app/shared/http";
import { withAuth } from "../../app/util/HOC";
import StudyCenterHeader from "./StudyCenterHeader";
import { handleException } from "../../app/util/util";
import { makeStyles } from "@material-ui/core/styles";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import ButtonToolbar from "react-bootstrap/ButtonToolbar";
import { usePagination } from "@material-ui/lab/Pagination";
import Spinner from "../Spinner/Spinner";
import loaderColors1 from "../Spinner/loaderColors1.gif";

const useStyles = makeStyles({
  ul: {
    listStyle: "none",
    padding: 0,
    margin: 0,
    display: "flex",
  },
});
export function StudyReadExplanation(props) {
  const userVO = JSON.parse(localStorage.getItem("userVO"));
  const keepMeLogIn = localStorage.getItem("keepLoggedIn") ? "true" : "false";
  const [bookVO, setBookVO] = useState(
    JSON.parse(localStorage.getItem("bookVO")),
  );
  const [totalQuestionCount, setTotalQuestionCount] = useState(0);
  const [questionBankVOList, setQuestionBankVOList] = useState(null);
  const [currentQuestion, setCurrentQuestion] = useState(null);
  const [loName, setLoName] = useState("");
  const [studyReferenceVOList, setStudyReferenceVOList] = useState(null);
  const classes = useStyles();
  useEffect(() => {
    async function fetchQuestions() {
      let reqData = {
        bookVO: { bookISBN: props.match.params.isbn },
        questionVO: {
          explainertype: "3",
          questionType: "explanatory",
          bookISBN: props.match.params.isbn,
          chapterId: props.match.params.chapterid,
          learningObjectId: props.match.params.loid,
        },
      };
      post(
        "/assessmentRetrievalService/getQuestionForStudyCenterLearnRv",
        reqData,
        "ENV",
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.status === "false" && data.wkErrorCode) {
            handleException(data);
          }
          if (data.status === "true") {
            let loName = data.learningObjName;
            if (data.assessmentVO && data.assessmentVO.questionBankVOList) {
              data.bookVO.chapterId = props.match.params.chapterid;
              let flag = 0;
              data.assessmentVO.questionBankVOList = Array.isArray(
                data.assessmentVO.questionBankVOList,
              )
                ? data.assessmentVO.questionBankVOList
                : [data.assessmentVO.questionBankVOList];
              for (
                let i = 0;
                i < data.assessmentVO.questionBankVOList.length;
                i++
              ) {
                if (
                  data.assessmentVO.questionBankVOList[i].questionResponseVO
                    .status === "not attempted"
                ) {
                  updateCurrentQuestionBtn(i + 1);
                  flag = 1;
                  setTotalQuestionCount(data.assessmentVO.countOfTotalQuestion);
                  setQuestionBankVOList(data.assessmentVO.questionBankVOList);
                  setCurrentQuestion(data.assessmentVO.questionBankVOList[i]);
                  setBookVO(data.bookVO);
                  setLoName(loName);
                  setStudyReferenceVOList(
                    data.assessmentVO.questionBankVOList[i].questionVO
                      .studyReferenceVOList,
                  );
                  break;
                }
              }
              if (flag === 0) {
                updateCurrentQuestionBtn(1);
                setTotalQuestionCount(data.assessmentVO.countOfTotalQuestion);
                setQuestionBankVOList(data.assessmentVO.questionBankVOList);
                setCurrentQuestion(data.assessmentVO.questionBankVOList[0]);
                setBookVO(data.bookVO);
                setLoName(loName);
                setStudyReferenceVOList(
                  data.assessmentVO.questionBankVOList[0].questionVO
                    .studyReferenceVOList,
                );
              }
            } else setLoName(loName);
          }
        })
        .catch((error) => {
          console.error(
            "There has been a problem with your fetch operation:",
            error,
          );
        });
    }
    fetchQuestions();
  }, []);
  // Load img from CDN
  const [imgLoading, setImgLoading] = useState(false);
  const loadImagesFromCDN = () => {
    let relativeUrl = "";
    let imgTags = document.querySelectorAll(
      "#studyReadExplanationFlashCardContainer img",
    );
    if (imgTags && imgTags.length > 0) {
      imgTags.forEach((img) => {
        img.classList.add("hidden-img");
        if (!img.src.toLowerCase().includes("question-images")) return;
        const imageName = img?.src.toLowerCase().split("question-images/")[1];
        let path = imageName?.split("_")[0];
        relativeUrl = `/casebook/${path}/ex-epub/OPS/images/${imageName}`;
        let reqData = {
          genericServiceRequestVO: { inputBaseUrl: relativeUrl },
        };
        post("/manageUrlService/getCDNUrl", reqData, "ENV")
          .then((response) => {
            setImgLoading(true);
            response.json();
          })
          .then((data) => {
            if (data.status === "true") {
              const cdnUrl = data.genericServiceResponseVO.cdnUrl;
              const tempImg = new Image();
              tempImg.onload = () => {
                img.src = cdnUrl;
                img.style.maxHeight = "450px";
                img.style.maxWidth = "100%";
                img.classList.remove("hidden-img");
                img.classList.add("visible-img");
                setImgLoading(false);
              };

              tempImg.src = cdnUrl;
            } else if (data.wkErrorCode) {
              handleException(data);
            }
          })
          .catch((error) => console.error(error))
          .finally(() => setImgLoading(false));
      });
    }
  };

  const updateCurrentQuestionBtn = (questionNumber, btnName) => {
    document.querySelectorAll(".questionNumberBtn").forEach((x) => {
      x.classList.remove("active-question-btn");
    });
    if (document.getElementById("btnQuestion_" + questionNumber - 1)) {
      document
        .getElementById("btnQuestion_" + questionNumber - 1)
        .classList.remove("active-question-btn");
      document.getElementById(
        "btnQuestion_" + questionNumber - 1,
      ).style.border = "inherit";
    }
    if (document.getElementById("btnQuestion_" + questionNumber + 1)) {
      document
        .getElementById("btnQuestion_" + questionNumber + 1)
        .classList.remove("active-question-btn");
      document.getElementById(
        "btnQuestion_" + questionNumber + 1,
      ).style.border = "inherit";
    }
    if (btnName === "Skip" || btnName === "Next") {
      if (document.getElementById("btnQuestion_" + questionNumber))
        document
          .getElementById("btnQuestion_" + questionNumber)
          .classList.add("active-question-btn");
      document
        .querySelectorAll(".questionNumberBtn")
        .forEach((x) => (x.style.border = "inherit"));
    }
  };
  const getQuestion = (e) => {
    if (
      parseInt(totalQuestionCount - 1) ===
      parseInt(e.target.getAttribute("arrayIndex"))
    ) {
      document
        .getElementById(
          `btnQuestion_${parseInt(currentQuestion.questionNumber) + 1}`,
        )
        .focus();
    }
    setCurrentQuestion(
      questionBankVOList[parseInt(e.target.getAttribute("arrayIndex"))],
    );
    updateCurrentQuestionBtn(
      parseInt(e.target.getAttribute("arrayIndex")) + 1,
      e.currentTarget.innerText,
    );
  };
  const navigateToStudyDashboard = (e) => {
    props.history.push(
      `/study/${props.match.params.isbn}/${props.match.params.chapterid}`,
    );
  };
  const { items } = usePagination({
    count: totalQuestionCount,
    pageProp: questionBankVOList,
    boundaryCount: 2,
    onChange: (e) => getQuestion(e),
  });
  const handleBackToStudyCenter = (e) => {
    if (e.key === "Enter") {
      navigateToStudyDashboard(e);
    }
  };
  useEffect(() => {
    if (currentQuestion?.questionVO?.questionText) {
      setTimeout(() => {
        loadImagesFromCDN();
      }, 0);
    }
  }, [currentQuestion]);
  console.log("imgLoading", imgLoading);
  return (
    <React.Fragment>
      {
        <Spinner
          loading={imgLoading}
          imageSrc={loaderColors1}
          overlayBackground="rgba(0,0,0,0.5)"
        />
      }{" "}
      <Header userVO={userVO} bookVO={bookVO} pageName="study"></Header>
      <StudyCenterHeader userVO={userVO} />
      <div className="col-lg-12">
        <div className="row greyDiv">
          <div className="col-xl-8 col-lg-7 col-md-5 col-sm-12 col-xs-12 headingDiv">
            <span className="insightProperty">{loName}</span>
            <br />
            <span className="insightHeading">Read Explanations</span>
            <br />
            <span
              className="studyLink cusorPointer"
              onClick={navigateToStudyDashboard}
              tabIndex="0"
              onKeyDown={(e) => handleBackToStudyCenter(e)}
            >
              {" "}
              Back to Study Center{" "}
            </span>
          </div>
          <div
            className="col-xl-4 col-lg-5 col-md-7 col-sm-12 col-xs-12"
            style={{ margin: "auto" }}
          >
            <ButtonToolbar
              aria-label="Toolbar with button groups"
              style={{ justifyContent: "center" }}
            >
              <ButtonGroup className="mr-2" aria-label="First group">
                <ul className={classes.ul}>
                  {items.map(({ page, type, selected, ...item }, index) => {
                    let children = null;
                    if (type === "start-ellipsis" || type === "end-ellipsis") {
                      if (
                        totalQuestionCount != "1" &&
                        parseInt(totalQuestionCount) > 6
                      ) {
                        children = (
                          <i
                            style={{ margin: "15px 5px 0 0" }}
                            className="fa fa-ellipsis-h"
                            aria-hidden="true"
                          ></i>
                        );
                      }
                    } else if (type === "page") {
                      if (
                        questionBankVOList !== null &&
                        questionBankVOList !== undefined
                      ) {
                        if (
                          questionBankVOList[page - 1].questionResponseVO !==
                            null &&
                          questionBankVOList[page - 1].questionResponseVO !==
                            undefined
                        ) {
                          if (
                            questionBankVOList[page - 1].questionResponseVO
                              .status === "incorrect"
                          ) {
                            children = (
                              <span>
                                <button
                                  {...item}
                                  style={{
                                    color: selected ? "#000000" : undefined,
                                    border: selected
                                      ? "1px solid #000"
                                      : undefined,
                                  }}
                                  arrayIndex={page - 1}
                                  id={
                                    "btnQuestion_" +
                                    questionBankVOList[page - 1].questionNumber
                                  }
                                  className="questionNumberBtn numberBox redBgColor"
                                >
                                  {page}
                                </button>{" "}
                                &nbsp;&nbsp;{" "}
                              </span>
                            );
                          } else if (
                            questionBankVOList[page - 1].questionResponseVO
                              .status === "correct"
                          ) {
                            children = (
                              <span>
                                <button
                                  {...item}
                                  style={{
                                    color: selected ? "#000000" : undefined,
                                    border: selected
                                      ? "1px solid #000"
                                      : undefined,
                                  }}
                                  arrayIndex={page - 1}
                                  id={
                                    "btnQuestion_" +
                                    questionBankVOList[page - 1].questionNumber
                                  }
                                  className="questionNumberBtn numberBox greenBgColor"
                                >
                                  {page}
                                </button>
                                &nbsp;&nbsp;{" "}
                              </span>
                            );
                          } else if (
                            questionBankVOList[page - 1].questionResponseVO
                              .status === "partial"
                          ) {
                            children = (
                              <span>
                                <button
                                  {...item}
                                  style={{
                                    color: selected ? "#000000" : undefined,
                                    border: selected
                                      ? "1px solid #000"
                                      : undefined,
                                  }}
                                  arrayIndex={page - 1}
                                  id={
                                    "btnQuestion_" +
                                    questionBankVOList[page - 1].questionNumber
                                  }
                                  className="questionNumberBtn numberBox blueBgColor"
                                >
                                  {page}
                                </button>
                                &nbsp;&nbsp;{" "}
                              </span>
                            );
                          } else {
                            children = (
                              <span>
                                <button
                                  {...item}
                                  style={{
                                    color: selected ? "#007AC3" : undefined,
                                    border: selected
                                      ? "1px solid #000"
                                      : undefined,
                                  }}
                                  arrayIndex={page - 1}
                                  id={
                                    "btnQuestion_" +
                                    questionBankVOList[page - 1].questionNumber
                                  }
                                  className="questionNumberBtn numberBox"
                                >
                                  {page}
                                </button>
                                &nbsp;&nbsp;{" "}
                              </span>
                            );
                          }
                        }
                      }
                    }
                    return <li key={index}>{children}</li>;
                  })}
                </ul>
              </ButtonGroup>
            </ButtonToolbar>
          </div>
        </div>
        <div className="row">
          <div className="studyDiv">
            {currentQuestion !== null ? (
              <div className="col-lg-12">
                {studyReferenceVOList !== null ? (
                  <>
                    {studyReferenceVOList.studyAidLink ? (
                      <div className="refLink">
                        From{" "}
                        <a href={studyReferenceVOList.studyAidLink}>
                          {studyReferenceVOList.studyAidTitle}
                        </a>
                      </div>
                    ) : null}
                  </>
                ) : null}
                <div
                  id="studyReadExplanationFlashCardContainer"
                  className="shortanswerht"
                >
                  <span
                    className="insightProperty"
                    style={{ fontFamily: "Arial" }}
                  >
                    {currentQuestion.questionVO !== null
                      ? parse(currentQuestion.questionVO.questionText)
                      : ""}
                  </span>
                </div>
                <div className="col-lg-1 pull-right">
                  {totalQuestionCount !== currentQuestion.questionNumber ? (
                    <Button
                      className="studyButton"
                      arrayIndex={currentQuestion.questionNumber}
                      onClick={getQuestion}
                    >
                      Next
                    </Button>
                  ) : null}
                  &nbsp;&nbsp;
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
      <Footer />
    </React.Fragment>
  );
}
export default withAuth(withRouter(StudyReadExplanation));
